<div class="table-view">
  <!-- Table starts -->
  <p-table
    [value]="otherSystemList"
    #dt
    [rows]="10"
    [paginator]="true"
    [pageLinks]="3"
    [rowsPerPageOptions]="[5, 10, 20]"
    alwaysShow="false"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
  >
    <!-- Caption -->
    <ng-template pTemplate="caption">
      <div class="ui-helper-clearfix">
        <div class="table-options">
          <div class="pull-right">
            <kuba-export
              [reportData]="dt.filteredValue || dt.value"
              [additionalData]="additionalData"
            >
            </kuba-export>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- Header -->
    <ng-template pTemplate="header">
      <tr>
        <th width="50px">{{ "SERIAL_NO" | translate }}</th>
        <th pSortableColumn="Title">
          {{ "NAME_ON_SYSTEM" | translate }}
          <p-sortIcon field="Title"></p-sortIcon>
        </th>
        <th pSortableColumn="Description">
          {{ "DESCRIPTION" | translate }}
          <p-sortIcon field="Description"></p-sortIcon>
        </th>
        <th width="100px">{{ "ASSIGNED_ACCESS" | translate }}</th>
        <th width="140px">{{ "DEVIATIONS_IN_FOLLOWUP" | translate }}</th>
        <th width="90px">{{ "OPTIONS" | translate }}</th>
      </tr>
      <tr>
        <th></th>
        <th>
          <input
            pInputText
            type="text"
            (input)="dt.filter($any($event.target)?.value, 'Title', 'contains')"
            placeholder=""
            class="p-column-filter"
          />
        </th>
        <th></th>
        <th></th>
        <th style="width: 125px"></th>
        <th></th>
      </tr>
    </ng-template>
    <!-- Body Content -->
    <ng-template pTemplate="body" let-otherSystem let-ic="rowIndex">
      <tr>
        <td>
          <span>{{ ic + 1 }}</span>
        </td>
        <td>
          <a [routerLink]="['./../../details', otherSystem.Id]" translate>{{
            otherSystem.Title
          }}</a>
        </td>
        <td>
          <span>{{ otherSystem.Description }}</span>
        </td>
        <td>
          <button
            type="button"
            class="btn btn-link"
            title="{{ 'View users' | translate }}"
            (click)="showAssignedUsers(otherSystem.OSUserDto)"
          >
            <span
              >{{ otherSystem.UserCount !== null ? otherSystem.UserCount : "" }}
            </span>
          </button>
        </td>
        <td>
          <input
            type="checkbox"
            [disabled]="isDisabled"
            [(ngModel)]="otherSystem.ShowDeviation"
          />
        </td>
        <td class="col-button">
          <a
            *ngIf="isAdministrateOs"
            routerLink="create"
            [routerLink]="['./../../create', otherSystem.Id]"
            
            title="{{ 'EDIT' | translate }}"
            routerLinkActive="active" [attr.aria-label]="'EDIT' | translate" class="kuba-icon-btn kuba-icon-btn--ghost kuba-icon-btn--row"><i class="pi pi-pencil"></i></a>
          <button
            type="button"
            *ngIf="isHideDeleteIcon"
            title="{{ 'DELETE' | translate }}"
            (click)="confirm(otherSystem.Id)"
            [attr.aria-label]="'DELETE' | translate" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
        </td>
      </tr>
    </ng-template>
    <!-- Empty message -->
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td colspan="7">
          {{ "NO_RECORDS_FOUND" | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
  <!-- Table Ends -->
</div>
<p-confirmDialog
  header="{{ 'CONFIRMATION' | translate }}"
  icon="pi pi-question-circle"
  width="425"
  acceptLabel="{{ 'SWITCH_YES' | translate }}"
  rejectLabel="{{ 'SWITCH_NO' | translate }}"
></p-confirmDialog>
<p-dialog
  header="{{ 'ASSIGNED_ACCESS' | translate }}"
  [(visible)]="showDialog"
  [modal]="true"
  [style]="{ width: '300px' }"
  [resizable]="false"
  [draggable]="false"
  (onHide)="onHide()"
>
  <div class="table-view">
    <!-- Table starts -->
    <p-table
      #et
      [value]="assignedUsers"
      [rows]="10"
      [paginator]="true"
      [pageLinks]="3"
      [rowsPerPageOptions]="[5, 10, 20]"
    >
      <!-- Header -->
      <ng-template pTemplate="header">
        <tr>
          <th>{{ "NAME" | translate }}</th>
        </tr>
        <tr>
          <th>
            <input
              pInputText
              type="text"
              (input)="
                et.filter($any($event.target)?.value, 'NameList', 'contains')
              "
              placeholder=""
              class="p-column-filter"
            />
          </th>
        </tr>
      </ng-template>
      <!-- Body Content -->
      <ng-template pTemplate="body" let-user>
        <tr>
          <td>
            <span>{{ user.NameList }}</span>
          </td>
        </tr>
      </ng-template>
      <!-- Empty message -->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td colspan="1">
            {{ "NO_RECORDS_FOUND" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
    <!-- Table Ends -->
  </div>
</p-dialog>
